import React, { forwardRef } from "react";
import { Box, BoxProps, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "@localization/useTranslation";
import { listRowAttribute, revealOnRowHoverAttribute, useDotLegalListStyles } from "./DotLegalList.styles";

export interface DotLegalListRowProps extends Omit<BoxProps, "children"> {
    children: React.ReactNode;
    startContent?: React.ReactNode;
    onRemove?: () => void;
}

const DotLegalListRow = forwardRef<HTMLDivElement, DotLegalListRowProps>(({ children, startContent, onRemove, sx, ...boxProps }, ref) => {
    const { translateString } = useTranslation();
    const styles = useDotLegalListStyles();

    return (
        <Box ref={ref} {...boxProps} {...{ [listRowAttribute]: true }} sx={[styles.row, ...(Array.isArray(sx) ? sx : [sx])]}>
            {startContent}
            {/* minWidth lets the content shrink below its longest word, so long content cannot push the remove button
                outside the list. */}
            <Box sx={styles.rowContent}>{children}</Box>
            {onRemove && (
                <IconButton
                    size="small"
                    aria-label={translateString("delete")}
                    sx={styles.removeButton}
                    onClick={onRemove}
                    {...{ [revealOnRowHoverAttribute]: true }}
                >
                    <CloseIcon sx={styles.removeIcon} />
                </IconButton>
            )}
        </Box>
    );
});

DotLegalListRow.displayName = "DotLegalListRow";

export default DotLegalListRow;
